import styled from 'styled-components'
import { FaSpinner } from 'react-icons/fa'
import Flex from './Flex'
import FlexItem from './FlexItem'

const StyledButton = styled.button.attrs((props) => ({
  color: props.color || '#405cf5',
  textColor: props.textColor || '#fff',
}))`
  cursor: pointer;
  position: relative;
  color: ${(props) => props.textColor};
  background-color: ${(props) => props.color};
  padding: 0 20px;
  border-radius: 8px;
  border-width: 0;
  height: 40px;
  width: auto;
  min-width: 100px;
  line-height: 1.2;
  text-align: center;
  ${(props) => props.uppercase && 'text-transform: uppercase'};
  font-weight: bold;
  transition-duration: 0.4s;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }

  &:hover:not(:disabled) {
    transition-duration: 0.1s;
    filter: brightness(120%);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }
`

const Spinner = styled(FaSpinner)`
  animation: rotate 2s linear infinite;
  font-size: 16px;
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`

const Button = ({ loading, ...props }) => {
  return (
    <StyledButton {...props}>
      <Flex alignItems='center' justifyContent='center'>
        {loading ? (
          <FlexItem>
            <Spinner />
          </FlexItem>
        ) : (
          <FlexItem>
            <Flex>
              {props.icon && <i style={{ marginRight: 6 }}>{props.icon}</i>}
              <span>{props.text}</span>
              <span>{props.children}</span>
            </Flex>
          </FlexItem>
        )}
      </Flex>
    </StyledButton>
  )
}

export default Button
